import React, { useState } from 'react';
import {
    cmToInches
  } from "../../utils/helper";
import { MdExpandLess, MdExpandMore } from 'react-icons/md';

const Dimension = ({ data }) => {
    const [isOpen, setIsOpen] = useState(true);

    const toggleAccordion = () => {
        setIsOpen(!isOpen);
    };

    const formatLength = (lengthInCm) => {
        if(lengthInCm < 100) {
            return lengthInCm + ' cm';
        }
 
        if (lengthInCm) {
            return (lengthInCm / 100).toFixed(2) + ' m';
        }

        return '--';
    }

    const formatWeight = (weightInGrams) => {
        const gramsToPounds = 0.00220462; // Conversion factor from grams to pounds
        const gramsToOunces = 0.03527396; // Conversion factor from grams to ounces
    
        if (weightInGrams < 453.592) { // 453.592 grams = 1 pound
            return (weightInGrams * gramsToOunces).toFixed(2) + ' oz';
        }
        if (weightInGrams) {
            return (weightInGrams * gramsToPounds).toFixed(2) + ' lb';
        }
        return '--';
    }
    

    const properties = [
        {
            title: 'Width',
            value: data?.width ? `${formatLength(data.width)} (${cmToInches(data.width)})` : '--'
        },
        {
            title: 'Height',
            value: data?.height ? `${formatLength(data.height)} (${cmToInches(data.height)})` : '--'
        },
        {
            title: 'Length',
            value: data?.length ? `${formatLength(data.length)} (${cmToInches(data.length)})` : '--'
        },
        {
            title: 'Weight',
            value: data?.weight ? formatWeight(data.weight) : '--'
        }

    ];

    return (
        <React.Fragment>
            <div className='flex flex-col w-full text-white'>
                <div className=''>
                    <div className='flex cursor-pointer items-center mb-2 justify-between'
                        onClick={toggleAccordion}>
                        <div className='mr-1 text-primary text-md font-bold'>
                            Dimensions
                        </div>
                        <div className="text-primary">
                            {isOpen ? <MdExpandMore className="w-6 h-6" /> : <MdExpandLess className="w-6 h-6" />}
                        </div>
                    </div>
                    {isOpen && (
                        <div className="bg-secondary-bg rounded-xl p-3">
                            {
                                properties.map((property, index) => (
                                    <div key={index} className="flex justify-between text-sm mb-1">
                                        <p>{property.title}</p>
                                        <p className='text-primary text-sm'>{property.value}</p>
                                    </div>
                                ))}
                        </div>
                    )}

                </div>
            </div>
        </React.Fragment>
    );
};

export default Dimension;
